import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { formatDate } from "../../../core/utils/configFormatters";
import { exportToCSV, exportToExcel, } from "../../../core/common/GlobalFunctions/exportTableData";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { Drawer, message } from "antd";
import dayjs from 'dayjs';
import {
  createWorkfromHome,
  UpdateWorkfromHome,
  getworkfromhomeById,
  getworkfromhomeByEmployeeId,
  fetchAllWorkformHome,
  DeleteWorkfromHome,
} from "../../../core/data/redux/attendance/workfromrequest/workfromhome.action";
import { getEmployeeByUserId } from "../../../core/data/redux/employee/employeeAction";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { decryptData } from "../../../core/utils/encryptUtils";

const WorkfromHome = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [isEditing, setIsEditing] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const { user } = useSelector((state: any) => state.auth);
  const { departments } = useSelector((state: any) => state.department);
  // const { workfromhome } = useSelector((state: any) => state.workfromHome);
  const departementData = departments ? departments : [];
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const { workfromhome, loadingStates } = useSelector(
    (state: any) => state.workfromHome
  );
  const isLoading = isEditing ? loadingStates.update : loadingStates.create;
  const [modalType, setModalType] = useState<"edit" | "create" | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const Id = selectedRowData?.Id;
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [employeeId, setemployeeId] = useState<any>("");
  const [employeeworkfromhome, setemployeeworkfromhome] = useState<any>([])

  const [formData, setFormData] = useState<any>({
    Days: "",
    FromDate: "",
    ToDate: "",
    Description: "",
    employeeId: employeeId ? employeeId : " ",
  });

  const formatDates = (dateStr: string) => {
    return dateStr ? dayjs(dateStr).format("YYYY-MM-DD") : "";
  };

  const handleEditPolicy = (record: any): void => {
    setIsEditing(true);
    setSelectedRowData(record);

    setFormData({
      Days: record.Days || "",
      FromDate: formatDates(record.FromDate),
      ToDate: formatDates(record.ToDate),
      Description: record.Description || "",
      employeeId: record.EmployeeId || "",
    });
  };

  const [errors, setErrors] = useState<any>({
    Days: "",
    FromDate: "",
    ToDate: "",
    Description: "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    let updatedFormData = { ...formData, [name]: value };

    if (
      (name === "FromDate" || name === "ToDate") &&
      updatedFormData.FromDate &&
      updatedFormData.ToDate
    ) {
      const from = dayjs(updatedFormData.FromDate);
      const to = dayjs(updatedFormData.ToDate);

      if (from.isBefore(to) || from.isSame(to, 'day')) {
        const calculatedDays = to.diff(from, 'day') + 1;
        updatedFormData.Days = calculatedDays.toString();
      } else {
        updatedFormData.Days = "";
      }
    }

    setFormData(updatedFormData);
  };



  const handleDelete = async (Id: any) => {
    try {
      dispatch(DeleteWorkfromHome(Id)).then((resp) => {
        if (resp.meta.requestStatus === "fulfilled") {
          setIsDeleteModalVisible(false);
          message.success(resp.payload.message);
          setTableKey((prevKey) => prevKey + 1);
          dispatch(getworkfromhomeByEmployeeId({ Id: employeeId }))
            .then((res) => {
              setemployeeworkfromhome(res?.payload.data)
            })
        } else {
          setIsDeleteModalVisible(false);
          message.error(resp.payload.message);
        }
      })
    } catch (error: any) {
      message.error("error is ", error);
    }
  };

  // const resetForm = () => {
  //   setFormData({
  //    Name: "",
  // CategoryType: "",
  // Description: "",
  // Status: "active",
  //   });
  //   setErrors({
  //    Name: "",
  // CategoryType: "",
  // Description: "",
  // Status: "active",
  //   });
  // };

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    // resetForm();
  };



  const validateForm = () => {
    const newErrors: any = {};

    if (!formData.Days && formData.Days !== 0) {
      newErrors.Days = "Number of Days is required.";
    } else if (formData.Days <= 0) {
      newErrors.Days = "Number of Days must be greater than 0.";
    }

    if (!formData.FromDate) {
      newErrors.FromDate = "From Date is required.";
    }

    if (!formData.ToDate) {
      newErrors.ToDate = "To Date is required.";
    }

    if (formData.FromDate && formData.ToDate) {
      const from = dayjs(formData.FromDate);
      const to = dayjs(formData.ToDate);

      if (to.isBefore(from)) {
        newErrors.ToDate = "To Date cannot be before From Date.";
      } else {
        const calculatedDays = to.diff(from, 'day') + 1;
        if (+formData.Days !== calculatedDays) {
          newErrors.Days = `Number of Days should be equal to based on From and To dates.`;
        }
      }
    }

    const keys = Object.keys(newErrors);
    if (keys.length > 0) {
      message.warning(newErrors[keys[0]]);
      return false;
    }

    return true;
  };

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");


  const onsubmit = async (e: any) => {
    try {
      e.preventDefault();
      const isValid = validateForm();
      if (!isValid) return;

      let payload = {
        ...formData,
        employeeId: employeeId || formData.employeeId || "",
      };

      if (modalType === "edit") {
        payload.ModifiedBy = user.UserId;
      } else {
        payload.CreatedBy = user.UserId;
      }

      Object.keys(payload).forEach((key) => {
        if (payload[key] === undefined || payload[key] === null) {
          delete payload[key];
        }
      });

      if (modalType === "edit") {
        const res = await dispatch(UpdateWorkfromHome({ Id: Id, data: payload }))
        if (res.meta.requestStatus === "fulfilled") {
          message.success(res.payload.message);
          dispatch(getworkfromhomeByEmployeeId({ Id: employeeId }))
            .then((res) => {
              setemployeeworkfromhome(res?.payload.data)
            })
          handleCancel()
          setTableKey((prevKey) => prevKey + 1);
        } else {
          message.warning(res.payload.error);
        }
      } else {
        dispatch(createWorkfromHome(payload))
          .then((resp) => {
            if (resp.meta.requestStatus === "fulfilled") {
              message.success(resp.payload.message);
              dispatch(getworkfromhomeByEmployeeId({ Id: employeeId }))
                .then((res) => {
                  setemployeeworkfromhome(res?.payload.data)
                })
              handleCancel()
              setTableKey((prevKey) => prevKey + 1);
            } else {
              message.warning(resp.payload.message);
            }
            handleCancel();
          })
      }
    } catch (error: any) {
      message.error("Error submitting form:", error);
    }
  };

  ///fetching the data
  useEffect(() => {
    if (!employeeId) {
      dispatch(getEmployeeByUserId({ userId: user.UserId })).then((res) => {
        setemployeeId(res?.payload.data?.employeeId);
      });
    }

    dispatch(fetchAllWorkformHome());
  }, [dispatch]);

  useEffect(() => {
    if (employeeId) {
      dispatch(getworkfromhomeByEmployeeId({ Id: employeeId }))
        .then((res) => {
          setemployeeworkfromhome(res?.payload.data)
        })
    }
  }, [dispatch, employeeId])

  const data = employeeworkfromhome ? employeeworkfromhome : [];

  const exportWorkFromHome = data?.map((item: any) => ({
    EmployeeName: item.EmployeeName || "N/A",
    Days: item.Days || "N/A",
    FromDate: item.FromDate ? new Date(item.FromDate).toLocaleDateString("en-IN") : "N/A",
    ToDate: item.ToDate ? new Date(item.ToDate).toLocaleDateString("en-IN") : "N/A",
    RequestStatus: item.RequestStatus || "Pending",
    // CreatedBy: item.CreatedBy || "N/A",
    CreatedAt: item.CreatedAt ? new Date(item.CreatedAt).toLocaleDateString("en-IN") : "N/A",
    // ModifiedBy: item.ModifiedBy || "N/A",
    ModifiedAt: item.ModifiedAt ? new Date(item.ModifiedAt).toLocaleDateString("en-IN") : "N/A",
    Description: item.Description || "N/A",
  }));

  const filteredData = useMemo(() => {
    const filters = selectedStatus && selectedStatus !== "All"
      ? { RequestStatus: selectedStatus }
      : {};
    return filterData(
      employeeworkfromhome || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [employeeworkfromhome, selectedStatus, selectedSort, dispatch]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, employeeworkfromhome, dispatch]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Employee Name",
      dataIndex: "EmployeeName",
      render: (text: String, record: any) => (
        <h6 className="fw-medium fs-14 text-dark">{text}</h6>
      ),
      sorter: (a: any, b: any) => a.EmployeeName.length - b.EmployeeName.length,
    },
    {
      title: "From Date",
      dataIndex: "FromDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.FromDate).getTime();
        const dateB = new Date(b.FromDate).getTime();
        return dateA - dateB;
      },
    },
    {
      title: "To Date",
      dataIndex: "ToDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.ToDate).getTime();
        const dateB = new Date(b.ToDate).getTime();
        return dateA - dateB;
      },
    },
    {
      title: "Request Status",
      dataIndex: "RequestStatus",
      sorter: (a: any, b: any) =>
        a.RequestStatus.length - b.RequestStatus.length,
    },
    {
      title: "Days",
      dataIndex: "Days",
      sorter: (a: any, b: any) => a.Days.length - b.Days.length,
    },
    {
      title: "Created Date",
      dataIndex: "CreatedAt",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.CreatedAt);
        const dateB = new Date(b.CreatedAt);
        return dateA.getTime() - dateB.getTime();
      },
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => {
        const isDisabled = record.RequestStatus === "Approved" || record.RequestStatus === "Rejected";

        return (
          <div className="action-icon d-inline-flex">
            <button
              className="me-2"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={isDisabled ? "Edit Disabled" : "Edit"}
              onClick={() => {
                if (!isDisabled) {
                  showModal("edit");
                  handleEditPolicy(record);
                }
              }}
              disabled={isDisabled}
            >
              <i className="ti ti-edit" />
            </button>

            <button
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title={isDisabled ? "Delete Disabled" : "Delete"}
              onClick={() => {
                if (!isDisabled) {
                  setSelectedRowData(record);
                  setIsDeleteModalVisible(true);
                }
              }}
              disabled={isDisabled}
            >
              <i className="ti ti-trash" />
            </button>
          </div>
        );
      },
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Work From Home</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Attendance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Work From Home Request
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canExport && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <button
                          onClick={() =>
                            exportToCSV(exportWorkFromHome, "WorkFromHome_data")
                          }
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() =>
                            exportToExcel(exportWorkFromHome, "WorkFromHome_data")
                          }
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() =>
                            exportToExcel(exportWorkFromHome, "WorkFromHome_data")
                          }
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as PDF{" "}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              {canAdd && (
                <div className="mb-2">
                  <button
                    className="btn btn-primary d-flex align-items-center"
                    onClick={() => showModal("create")}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Request
                  </button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Policy list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Request List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Type"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Pending")}
                        className="dropdown-item rounded-1"
                      >
                        Pending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Approved")}
                        className="dropdown-item rounded-1"
                      >
                        Approved
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Rejected")}
                        className="dropdown-item rounded-1"
                      >
                        Rejected
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Policylist list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Policy */}
      <Drawer
        title={
          modalType === "edit" ? "Edit Work From Home" : "Add Work From Home"
        }
        placement="right"
        width={560}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form>
          <div className="modal-body pb-0">
            <div className="row">


              {/* From Date */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  From Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="FromDate"
                  value={formData.FromDate}
                  onChange={handleChange}
                  min={dayjs().format("YYYY-MM-DD")}
                />

              </div>

              {/* To Date */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  To Date <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  className="form-control"
                  name="ToDate"
                  value={formData.ToDate}
                  onChange={handleChange}
                  min={dayjs().format("YYYY-MM-DD")}
                />
              </div>

              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Number Of Days <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  name="Days"
                  value={formData.Days}
                  onChange={handleChange}
                  disabled
                />
                {/* {errors.Days && <div className="invalid-feedback">{errors.Days}</div>} */}
              </div>

              {/* Description */}
              <div className="col-md-12 mb-3">
                <label className="form-label">Description</label>
                <textarea
                  className="form-control"
                  name="Description"
                  value={formData.Description}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-white border me-2"
              onClick={handleCancel}
            >
              Cancel
            </button>
            {/* <button
              type="button"
              className="btn btn-primary"
              onClick={onsubmit}
              disabled={isLoading}
            >
              {modalType === "edit" ? "Edit Request" : "Add Request"}
            </button> */}
            <button
              type="button"
              className="btn btn-primary"
              onClick={onsubmit}
              disabled={isLoading}
            >
              {isLoading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              {isLoading
                ? modalType === "edit"
                  ? "Updating..."
                  : "Submitting..."
                : modalType === "edit"
                  ? "Edit Request"
                  : "Add Request"}
            </button>
          </div>
        </form>
      </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDelete(selectedRowData.Id)
        }
      />
    </>
  );
};

export default WorkfromHome;
